import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('issuer_status', '/issuer_statuses')
const reducer = generator.generate()

export default reducer
